import React from 'react';
import { useTranslation } from 'react-i18next';
import './TermsAndConditionsField.scss';
import LinkButton from 'components/linkButton/LinkButton';

interface TermsAndConditionsFieldProps {
  isReadonly?: boolean;
  onTermsClick?: () => void;
  onPrivacyPolicyClick?: () => void;
}

const TermsAndConditionsField: React.FC<TermsAndConditionsFieldProps> = ({
  isReadonly = false,
  onTermsClick,
  onPrivacyPolicyClick,
}) => {
  const { t } = useTranslation('terms_and_conditions');

  const handleTermsClick = () => {
    // Handle opening terms and conditions
    onTermsClick?.();
  };

  const handlePrivacyPolicyClick = () => {
    // Handle opening privacy policy
    onPrivacyPolicyClick?.();
  };

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  return (
    <div className="terms-and-conditions-field-wrapper">
      <span className="terms-prefix">
        {isReadonly ? t('agreeTerms') : t('termsClick') + t('agreeTerms')}
      </span>

      <span onClick={stopPropagation} style={{ display: 'inline-block' }}>
        <LinkButton onClick={handleTermsClick} title={t('termsConditions')} />
      </span>

      <span className="terms-separator">{t('and')}</span>

      <span onClick={stopPropagation} style={{ display: 'inline-block' }}>
        <LinkButton
          onClick={handlePrivacyPolicyClick}
          title={t('customerPrivacyPolicy')}
        />
      </span>
    </div>
  );
};

export default TermsAndConditionsField;
